import React, { useState, useEffect } from 'react';
import axios from 'axios';
import UserModal from './UserModal';

const API_URL = '/api';

function UsersPage({ token }) {
  const [users, setUsers] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  useEffect(() => {
    loadUsers();
    loadFacilities();
  }, []);

  const loadUsers = async () => {
    try {
      const response = await axios.get(`${API_URL}/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(response.data);
    } catch (err) {
      console.error('Kullanıcılar yüklenemedi:', err);
    }
  };

  const loadFacilities = async () => {
    try {
      const response = await axios.get(`${API_URL}/facilities`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFacilities(response.data);
    } catch (err) {
      console.error('Tesisler yüklenemedi:', err);
    }
  };

  const deleteUser = async (id) => {
    if (!window.confirm('Bu kullanıcıyı silmek istediğinizden emin misiniz?')) return;
    
    try {
      await axios.delete(`${API_URL}/users/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Kullanıcı silindi');
      loadUsers();
    } catch (err) {
      alert('Hata: ' + err.response?.data?.error);
    }
  };

  return (
    <div className="admin-page">
      <div className="card">
        <h3>
          👥 Kullanıcı Yönetimi
          <button onClick={() => setShowAddModal(true)} className="btn-add">
            + Yeni Kullanıcı
          </button>
        </h3>

        <div className="user-list">
          {users.map(user => (
            <div key={user._id} className="user-card">
              <div className="user-info">
                <h4>{user.username}</h4>
                <div className="user-meta">
                  <span className={`role-badge ${user.role === 'admin' ? 'role-admin' : 'role-user'}`}>
                    {user.role === 'admin' ? '👑 Admin' : '👤 Kullanıcı'}
                  </span>
                  <span>📍 {user.facilities?.length || 0} Tesis</span>
                  <span>{user.isActive ? '✓ Aktif' : '✗ Pasif'}</span>
                </div>
              </div>
              <div className="action-buttons">
                <button 
                  className="btn-edit"
                  onClick={() => setEditingUser(user)}
                >
                  ✏️
                </button>
                <button 
                  className="btn-delete"
                  onClick={() => deleteUser(user._id)}
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {(showAddModal || editingUser) && (
        <UserModal
          user={editingUser}
          facilities={facilities}
          token={token}
          onClose={() => {
            setShowAddModal(false);
            setEditingUser(null);
          }}
          onSuccess={() => {
            setShowAddModal(false);
            setEditingUser(null);
            loadUsers();
          }}
        />
      )}
    </div>
  );
}

export default UsersPage;
